export default __webpack_public_path__ + "static/media/adv-1.7d8aa78b.jpg";